module.exports = __webpack_public_path__ + "img/city-pink.1bccb6d8.svg";